import { cn } from "../lib/cn";
import { CallSketch, SB_MONO } from "./CallSketch";

/**
 * Features, "Slack threads, live.": Maya asks what the customer said, and the Slack thread pops up, as the
 * product draws a slack_message card (the message as the title, #channel · author).
 */
export const SLACK_SKETCH = {
  speaker: "Maya",
  said: "What did the customer actually say about checkout last week?",
  message: "Acme: checkout still failing on retry",
  where: "#support · Dana",
} as const;

export function SlackCardSketch() {
  return (
    <CallSketch speaker={SLACK_SKETCH.speaker} said={SLACK_SKETCH.said} app="slack" label="Slack">
      <p className="text-[11px] font-semibold leading-tight">{SLACK_SKETCH.message}</p>
      <p className={cn("mt-0.5 text-[8px] leading-snug text-[#94A3B8]", SB_MONO)}>{SLACK_SKETCH.where}</p>
    </CallSketch>
  );
}
